
define('text!presentation/settings/voicemailBoxes/views/addVoicemailBoxSubscribers.html',[],function () { return '<div class="voicemail-subscribers"\n     data-bind="compose: { model: subscriberSelectionViewModel, activate: false }">\n</div>';});

